// src/realms/wilds/index.ts
var GENRE_HUE = {
  drama: 70,
  // oak — warm green-gold
  thriller: 150,
  // pine — cool green
  horror: 25,
  // dead/gnarled — burnt umber
  comedy: 95,
  // birch — bright spring
  romance: 330,
  // cherry blossom — pink
  scifi: 180,
  // alien luminescent
  documentary: 110,
  // generic forest green
  animation: 280
  // fantasy violet
};
function clamp01(n) {
  return Math.max(0, Math.min(1, n));
}
function popularityToIntensity(film) {
  const watches = Math.max(0, film.watch_starts_count);
  const log = Math.log10(1 + watches);
  return clamp01(log / 6);
}
function deriveScale(film) {
  const scenes = film.scenes_count ?? 1;
  return clamp01(0.3 + Math.log10(1 + scenes) / 3);
}
function deriveHue(film) {
  const genreKey = (film.genre ?? "").toLowerCase().replace(/[^a-z]/g, "");
  const hue = GENRE_HUE[genreKey];
  return hue !== void 0 ? hue : 110;
}
function deriveState(film) {
  return film.published ? "default" : "new";
}
var wildsMapping = (film) => ({
  position: [0, 0, 0],
  // assigned by the realm's spatial layouter
  scale: deriveScale(film),
  hue: deriveHue(film),
  intensity: popularityToIntensity(film),
  state: deriveState(film),
  metadata: {
    title: film.title,
    popularity: film.watch_starts_count,
    genre: film.genre
  }
});
var wildsMotion = {
  // Walking is slower and more grounded than flying through space.
  flightAcceleration: 8,
  flightDamping: 0.86,
  focusEaseMs: 480,
  engageDurationMs: 1100,
  backDurationMs: 1100
};
var wildsAudio = {
  ambientLoop: "audio/wilds/ambient-forest.ogg",
  focusChime: "audio/wilds/leaf-rustle.ogg",
  engageImpact: "audio/wilds/bark-open.ogg",
  backWhoosh: "audio/wilds/bark-close.ogg"
};

export { wildsAudio, wildsMapping, wildsMotion };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map